import { useQueryClient } from "@tanstack/react-query";
import { markNextActionAsCompleted } from "../api";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

export const useCompleteNextAction = () => {
  const queryClient = useQueryClient();
  return useDomainMutation({
    mutationFn: markNextActionAsCompleted,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["track-next-actions"] });
    },
  });
};
